/**
 * Copyright (c) 2019 Vendor Badge, LLC All Rights Reserved.
 * Created Date: Sunday, 17th February 2019
 *
 *  Portal - Login View/Registration Wizard/Company Profile
 */
import React from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import CompanyNameForm from 'components/Forms/CompanyNameForm';
import TextFieldWithValidation from 'components/InputFields/TextFieldWithValidation';

// Material UI Components
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';

import LogoInput from 'components/InputFields/Logo';
import { useStores } from 'stores/RootStore';

const CompanyProfile = props => {
  const { classes } = props;
  const stores = useStores();
  const { companyBio, companyLogoUrl, handleLogoChange, handleCompanyInputUpdate } = stores.registrationStore;
  return (
    <form id='company-profile' autoComplete='off'>
      <Grid container justify='center' className={classes.gridContainer}>
        <Grid item sm={7} xs={12} className={classes.addressGridItem}>
          <Grid item xs={12}>
            <Typography variant='body1' color='textSecondary' className={classes.sectionTitle}>
              Where do you work?
            </Typography>
            <Divider className={classes.sectionDivider} />
            <CompanyNameForm
              address1
              address2
              city
              state
              zip
              handleInputUpdate={handleCompanyInputUpdate}
              toStore={true}
              store={stores.registrationStore}
              prefix={'company'}
            />
          </Grid>
        </Grid>
        <Grid item sm={5} xs={12} className={classes.logoGrid}>
          <Grid item xs={12}>
            <Typography variant='body1' color='textSecondary' className={classes.sectionTitle}>
              Company Logo...
            </Typography>
            <Divider className={classes.sectionDivider} />
          </Grid>
          <Grid container justify='center' direction='column' alignItems='center'>
            <Grid item xs={12} className={classes.logoInput}>
              <LogoInput url={companyLogoUrl} handleLogoChange={handleLogoChange} />
              <Typography variant='h6' color='textSecondary' className={classes.logoFooter}>
                Upload Logo
              </Typography>
              <Typography variant='caption' color='textSecondary' style={{ textAlign: 'center' }}>
                {'( gif, jpg, png )'}
              </Typography>
            </Grid>
          </Grid>
          <Typography variant='body1' color='textSecondary' className={classes.sectionTitle}>
            Company Bio...
          </Typography>
          <Divider className={classes.sectionDivider} />
          <TextFieldWithValidation
            id='company-bio'
            name='Bio'
            helperText='Visible to all VendorBadge users.'
            multiline
            rows='6'
            visible
            value={companyBio}
            handleInputChange={handleCompanyInputUpdate}
            fullWidth
            margin='dense'
            InputLabelProps={{
              className: classes.inputLabelText,
            }}
            InputProps={{
              className: classes.inputTextBio,
            }}
          />
        </Grid>
      </Grid>
    </form>
  );
};

CompanyProfile.propTypes = {
  classes: PropTypes.object.isRequired,
};

const styles = theme => ({
  gridContainer: {},
  addressGridItem: {
    paddingLeft: '5px',
    paddingRight: '35px',
    paddingBottom: '5px',
    [theme.breakpoints.down('xs')]: {
      paddingRight: '15px',
      paddingLeft: '15px',
    },
  },
  inputIcon: {
    color: theme.palette.type === 'light' ? 'rgb(128, 128, 128)' : theme.palette.common.white,
    padding: '0',
  },
  logoGrid: {
    paddingLeft: '35px',
    paddingRight: '5px',
    paddingBottom: '5px',
    [theme.breakpoints.down('xs')]: {
      paddingRight: '15px',
      paddingLeft: '15px',
    },
  },
  logoInput: {
    paddingTop: '3px',
  },
  logoFooter: {
    fontSize: '10pt',
    textAlign: 'center',
  },
  sectionTitleGrid: {
    marginBottom: '10px',
  },
  sectionTitle: {
    marginLeft: '-5px',
    marginTop: '15px',
    fontWeight: 600,
    color: theme.palette.primary.light,
  },
  sectionDivider: {
    width: '100%',
    marginLeft: '-5px',
    marginBottom: '10px',
  },
  companyName: {
    padding: '2px',
    paddingRight: '20px',
    [theme.breakpoints.down('xs')]: {
      padding: '2px',
    },
  },
  phoneNumber: {
    padding: '2px',
    paddingRight: '20px',
    [theme.breakpoints.down('xs')]: {
      padding: '2px',
    },
  },
  inputLabelText: {
    fontSize: '11pt',
    [theme.breakpoints.down('xs')]: {
      fontSize: '10pt',
    },
  },
  inputTextBio: {
    fontSize: '10pt',
  },
});
export default withStyles(styles, { withTheme: true })(inject('registrationStore')(observer(CompanyProfile)));
